module.exports = {
  title: 'React Native Metaball Animation 🌐',
  author: 'Enzo Manuel Mangano',
  date: '2023-03-01',
  slug: 'metaball',
  tags: ['skia'],
};
